<section class="nrc-promo">
  <picture class="nrc-promo__bg">
    <source srcset="assets/images/promotions-banner-bg.webp" type="image/webp" />
    <img src="assets/images/promotions-banner-bg.png" alt="" aria-hidden="true" />
  </picture>
  <div class="nrc-promo__centered">
    <h2>{{ heading }}</h2>
    <app-new-roof-cost-zip-form
      placeholder="Enter your zip code"
      [fetchedZipcode]="fetchedZipcode"
    />
  </div>
</section>
